// extracted by mini-css-extract-plugin
module.exports = {"movieCard":"MovieCard_movieCard__2K7Aj","movieImage":"MovieCard_movieImage__1kj_k"};